export class IRevisionHistory {
  Revisions: IRevision[]
}

export class IRevision {
  revisionNumber: number;
  modifiedBy: string;
  modifiedDate: Date;
  activeFlag: string;
}

